import React, { useEffect, useState } from "react";
import FocusAreas from "./FocusAreas";
import AnalystsReport from "./AnalystsReport";
import News from "./News";
import EarlyWarningSigns from "./EarlyWarningSigns";
import Signals from "./Signals";
import CustomChatbot from "./CustomChatbot";
import CustomTabPanel from "./TabPanel";
import { Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useClientContext } from "../context/ClientContext";
import { response } from "../assets/response";
import axiosInstance from "../utils/axios";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import MarketLandscape from "./MarketLandscape";
import IndustryRegulations from "./IndustryRegulations";
import IndustryBenchmark from "./IndustryBenchmark";
import CompetitiveAnalysis from "./CompetitiveAnalysis";
import Geopolitics from "./Geopolitics";
import TerrainIcon from "@mui/icons-material/Terrain";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import BarChartIcon from "@mui/icons-material/BarChart";
import PublicIcon from "@mui/icons-material/Public";
import GroupsIcon from "@mui/icons-material/Groups";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLoading } from "../context/LoadingContext";

function IndustryInsights() {
  const [value, setValue] = React.useState(0);
  const { clientName, clientGroup } = useClientContext();
  //const responseJson = response;
  const [responseJson, setResponseJson] = useState({});
  const { showLoading, hideLoading } = useLoading();
  const [error, setError] = useState({});

  useEffect(() => {
    // Fetch data when component mounts or when client selection changes
    fetchData();
  }, [clientGroup]); // Re-run effect when these values change

  const fetchData = async () => {
    try {
      showLoading();
      const response = await axiosInstance.post("/industry_insight", {
        client_id: clientGroup,
      });
      //console.log('response', response.data);
      setResponseJson(response.data); // Handle successful response
    } catch (err) {
      setError("Error!!"); // Handle error
    } finally {
      hideLoading();
    }
  };

  return responseJson ? (
    <Grid container sx={{ height: "80vh", overflowY: "auto" }}>
      <Grid item size={12} pt={2}>
        {/* Industry Regulation */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <TextSnippetIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">
                Industry Regulations
              </h2>
              <div
                className="inline-block px-2 font-medium text-xs rounded-full"
                style={{ backgroundColor: "#00555C", color: "white" }}
              >
                NEW
              </div>
            </div>
            <Tooltip
              title="Summarize the latest and most relevant regulatory updates affecting the industry "
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <IndustryRegulations
              industryRegulations={responseJson.industry_regulation || []}
            />
          </AccordionDetails>
        </Accordion>
        {/* Competitive Analysis */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <MonitorHeartOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">
                Competitive Analysis
              </h2>
              <div
                className="inline-block px-2 font-medium text-xs rounded-full"
                style={{ backgroundColor: "#00555C", color: "white" }}
              >
                NEW
              </div>
            </div>
            <Tooltip
              title="Highlights Business Strategy and key initiatives of Domestic and International competitors"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <CompetitiveAnalysis
              competitiveAnalysis={responseJson.competitive_analysis || []}
            />
          </AccordionDetails>
        </Accordion>
        {/* Market Landscape */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <TerrainIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Market Landscape</h2>
            </div>
            <Tooltip
              title="Summarizes Industry outlook to provide insights pertaining to  Emerging trends,Innovation Outlook,Customer Behaviour etc for the chosen industry"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <MarketLandscape
              marketLandscape={responseJson.market_landscape || []}
            />
          </AccordionDetails>
        </Accordion>

        {/* Industry Benchmark */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <BarChartIcon className="text-main" />

              <h2 className="text-xs font-bold text-main">
                Industry Benchmark
              </h2>
            </div>
            <Tooltip
              title="Offers insights on Company performance compared to its peers in the same industry based on identified Key Performance Indicators"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <IndustryBenchmark
              industryBenchmark={responseJson.industry_benchmark || []}
            />
          </AccordionDetails>
        </Accordion>

        {/* Geopolitics */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <PublicIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Geopolitics </h2>
            </div>
            <Tooltip
              title="Provides insights on the global/ regional events which impacts the client’s industry and business "
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <Geopolitics geopolitics={responseJson.geopolitics || []} />
          </AccordionDetails>
        </Accordion>

        {/* Signals */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <WifiOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Insights</h2>
            </div>
            <Tooltip
              title="Identifies strategic opportunities, and financial partnerships that can enhance market positioning and business growth"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <Signals
              signals={responseJson.signals || []}
              industryInsights={true}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  ) : null;
}

export default IndustryInsights;
